var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-loading-section',{staticClass:"tab-loading-section",attrs:{"loading":_vm.isLoading}},[_c('stats-team-chart',{attrs:{"chart-data":_vm.tasks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }